var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar"},[_c('div',{ref:"progress",staticClass:"progress",class:_vm.type,style:({width: _vm.type === 'full' ? '100%' : ((100/_vm.slides) + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }